import axios from 'axios';

//自动切换环境
// if (process.env.NODE_ENV == 'development'){
//     axios.defaults.baseURL = '/api';
// } else if (process.env.NODE_ENV == 'debug'){
//     axios.defaults.baseURL = '/api';
// } else if (process.env.NODE_ENV == 'production') { 
//     axios.defaults.baseURL = 'http://***********/';
// }

// 携带cookie
axios.defaults.withCredentials = true;
//设置超时时间
axios.defaults.timeout = 10000;
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

//对外接口
export function request({method, url, params}){
    if(method == 'GET'){
        return get(url, params);
    }else if(method == 'POST'){
        return post(url, params);
    }
}

// 封装get方法
function get(url, params){
    return new Promise((resolve, reject) =>{
        axios.get(url, params).then(res =>{
            resolve(res);
        }).catch(err =>{
            reject(err);
        })
    });

}

// 封装post方法
function post(url, params){
        return new Promise((resolve, reject) =>{
        axios({
            method: "post",
            url,
            params,
            headers: {
                'Content-Type':'application/json'
            }
        }).then((res)=>{
            console.log('11')
            resolve(res)
        }).catch(err=>{
            reject(err)
        })
    });
}